export const MY_PURCHASES_LINK_HREF = '/my-purchases'
export const CHECKOUT_DELIVERY_PATHNAME = '/checkout/delivery'
export const CHECKOUT_GIFT_VOUCHER_PATHNAME = '/checkout/gift-voucher'
export const CHECKOUT_AUTHENTICATION_PATHNAME = '/checkout/authentication'
export const MY_CARDS = '/my-cards'
export const REFUNDS_LINK_HREF = '/refunds'
export const MY_RETURNS_LINK_HREF = '/my-returns'
export const ACCOUNT_BALANCE_LINK_HREF = '/account-balance'
export const HELP_LINK_HREF = '/help'
